(() => {
  const announcement = document.querySelector('announcement-bar');
  const stickyHeader = document.querySelector('.growthlab-header');
  const measureHeader = () => {
    const announcementHeight = announcement?.getBoundingClientRect().height || 0;
    document.documentElement.style.setProperty('--growthlab-announcement-height', `${announcementHeight}px`);
    if (stickyHeader?.classList.contains('@sticky')) document.documentElement.style.setProperty('--header-height', `${stickyHeader.offsetHeight + announcementHeight}px`);
  };
  measureHeader();
  if ('ResizeObserver' in window) {
    const sizeObserver = new ResizeObserver(measureHeader);
    if (announcement) sizeObserver.observe(announcement);
    if (stickyHeader) sizeObserver.observe(stickyHeader);
  }
  window.addEventListener('load', measureHeader, {once:true});
  document.querySelectorAll('[data-navigation-dropdown]').forEach(dropdown => {
    dropdown.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || !dropdown.open) return;
      event.preventDefault();
      event.stopPropagation();
      dropdown.open = false;
      dropdown.querySelector('summary').focus();
    });
    document.addEventListener('click', event => {
      if (!dropdown.contains(event.target)) dropdown.open = false;
    });
  });
  const keepPreviewOnSubmit = (form, previewTheme) => form?.addEventListener('submit', event => {
    const chosen = event.submitter?.value || form.querySelector('[name="language_code"]')?.value;
    try { if (chosen) localStorage.setItem('gl-lang-choice', chosen); } catch (error) {}
    const destination = new URL(window.location.href);
    let returnTo = form.querySelector('input[name="return_to"]');
    if (!returnTo) {
      returnTo = document.createElement('input');
      returnTo.type = 'hidden';
      returnTo.name = 'return_to';
      form.append(returnTo);
    }
    returnTo.value = destination.pathname + destination.search + destination.hash;
  });
  document.querySelectorAll('[data-header-language-toggle]').forEach(toggle => keepPreviewOnSubmit(toggle.querySelector('form'), toggle.dataset.previewTheme));
  document.querySelectorAll('[data-header-localization]').forEach(language => {
    keepPreviewOnSubmit(language.querySelector('form'), language.dataset.previewTheme);
    language.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        language.open = false;
        language.querySelector('summary').focus();
      }
    });
    document.addEventListener('click', event => {
      if (!language.contains(event.target)) language.open = false;
    });
  });
  const closeSearch = (search) => {
    const button = search.querySelector('[data-header-search-toggle]');
    search.removeAttribute('data-open');
    button?.setAttribute('aria-expanded', 'false');
  };

  document.querySelectorAll('[data-header-search]').forEach((search) => {
    const button = search.querySelector('[data-header-search-toggle]');
    const input = search.querySelector('input[name="q"]');
    if (!button || !input) return;

    button.addEventListener('click', () => {
      const open = search.hasAttribute('data-open');
      if (open) {
        closeSearch(search);
        return;
      }

      search.setAttribute('data-open', '');
      document.querySelectorAll('[data-header-menu]').forEach(menu => { if (menu.open) menu.close(); });
      button.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(() => input.focus());
    });

    search.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeSearch(search);
        button.focus();
      }
    });
    document.addEventListener('click', event => {
      if (!search.contains(event.target)) closeSearch(search);
    });
  });

  document.querySelectorAll('[data-header-menu]').forEach(menu => {
    const trigger = menu.parentElement.querySelector('[data-menu-open]');
    trigger.addEventListener('click', () => {
      document.querySelectorAll('[data-header-search]').forEach(closeSearch);
      menu.showModal();
      trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('gl-menu-open');
    });
    menu.querySelector('[data-menu-close]').addEventListener('click', () => menu.close());
    menu.addEventListener('click', event => {
      const rect = menu.getBoundingClientRect();
      if (event.target === menu && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) menu.close();
      if (event.target.closest('a')) menu.close();
    });
    menu.addEventListener('close', () => {
      trigger.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('gl-menu-open');
      trigger.focus();
    });
    matchMedia('(min-width: 992px)').addEventListener('change', event => { if (event.matches && menu.open) menu.close(); });
  });
})();
